import Button from "../../base/Button";

const renderIcon = (color) => (
    <svg width="29px" height="25px" viewBox="0 0 29 25" version="1.1">
        <title>align-top</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g
            id="Lightsmap-2.0"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="square"
        >
            <g
                id="Select-Manual"
                transform="translate(-224.000000, -71.000000)"
                stroke={color}
            >
                <g id="toolbar" transform="translate(0.000000, 60.000000)">
                    <g
                        id="Group-10"
                        transform="translate(212.200000, 11.500000)"
                    >
                        <g
                            id="align-top"
                            transform="translate(12.109591, 0.000000)"
                        >
                            <path d="M27.36,0.48 L0.48,0.48" id="Shape" />
                            <rect
                                id="Rectangle-path"
                                x="16.8"
                                y="6.24"
                                width="6.72"
                                height="17.28"
                            />
                            <rect
                                id="Rectangle-path"
                                x="4.32"
                                y="6.24"
                                width="6.72"
                                height="8.64"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

/**
 * Toolbar button for aligning selected lights to the top.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered align top button.
 */
const AlignTopButton = (props) => <Button {...props} renderIcon={renderIcon} />;

export default AlignTopButton;
